import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

/* Valtech Custom Code */
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { LISTS_LIST } from "@store/theme/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
/* Valtech Custom Code */

export interface CardContainerStyles {
    cardDivider?: InjectableCss;
    gridItem?: GridItemProps;
}

export const cardContainerStyles: CardContainerStyles = {
    gridItem: {
        width: 12,
        css: css`
            position: relative;
        `,
    },
    cardDivider: {
        css: css`
            position: relative;
            width: 100%;
            height: 100%;
            &::before {
                content: "";
                display: block;
                position: absolute;
                bottom: 0;
                height: 1px;
                width: 100%;
                background-color: ${getColor("common.border")};

                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [
                            {
                                values: LISTS_LIST.gridVerticalGap.map(x => (x ? `calc((-${x} / 2) - 1px)` : null)),
                                properties: ["bottom"],
                            },
                        ],
                        mediaOptions.min,
                    )}
            }
        `,
    },
};

const CardContainer: FC<{
    extendedStyles?: CardContainerStyles;
}> = ({ extendedStyles, children }) => {
    const [styles] = React.useState(() => mergeToNew(cardContainerStyles, extendedStyles));

    return (
        /* Valtech Custom Code */
        <GridItem {...styles.gridItem}>
            <StyledWrapper {...styles.cardDivider}>{children}</StyledWrapper>
        </GridItem>
        /* Valtech Custom Code */
    );
};

export default CardContainer;
